import { render } from "./PhonePausedOutline.vue?vue&type=template&id=49876a76"
import script from "./PhonePausedOutline.vue?vue&type=script&lang=js"
export * from "./PhonePausedOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__